import {DateTime} from 'luxon'

const getDateAsAstring = (date: Date) => {
  // Returns a string in the format of 'YYYY-MM-DD'
  return DateTime.fromJSDate(date).toISODate()
}

export default getDateAsAstring
